import { useContext, useMemo } from 'react';
import { Info } from 'lucide-react';

import { dummySiteRevenueOpportunity } from '@/components/pages/home/site-list/dummy-data';
import { Link } from '@/components/ui/link';
import { Tooltip } from '@/components/ui/tooltip';

import { PotentialGain } from '../entities/site-list';

import { SiteListItemContext } from './site-list-item';

export function SiteListItemRevenueOpportunity() {
  const site = useContext(SiteListItemContext);

  const revenueOpportunityMap = useMemo(() => {
    return new Map(
      dummySiteRevenueOpportunity.map((item) => [item.fullFrontendId, item]),
    );
  }, []);

  if (!site) return null;

  const siteRevenueData = revenueOpportunityMap.get(site.fullFrontendId);
  if (!siteRevenueData) return null;

  const { revenueOpportunity, potentialGain } = siteRevenueData;
  return (
    <Link to="/benchmark" className="block">
      <div className="flex items-center justify-between border-t px-5 py-3 transition-colors hover:bg-gray-50">
        <div className="flex items-center gap-1">
          <span className="text-sm font-medium text-gray-700">
            Additional Revenue Opportunity:
          </span>
          <span className="text-sm font-bold text-green-600">
            ${revenueOpportunity.toLocaleString()} per month
          </span>
          <Tooltip content="Addressing SOC Offsets and SOC Imbalances unlocks more capacity and boosts revenue.">
            <Info className="size-3.5 text-gray-400" />
          </Tooltip>
        </div>

        <SiteListItemPotentialGain level={potentialGain} />
      </div>
    </Link>
  );
}

function SiteListItemPotentialGain({ level }: { level: PotentialGain }) {
  return (
    <div className="flex items-center gap-1">
      <span className="text-xs text-gray-500">Potential Gain:</span>
      <div className="flex gap-0.5">
        <div
          className={`h-2 w-6 rounded-sm ${
            level === PotentialGain.High
              ? 'bg-green-500'
              : level === PotentialGain.Medium
                ? 'bg-green-300'
                : 'bg-green-100'
          }`}
        />
        <div
          className={`h-2 w-6 rounded-sm ${
            level === PotentialGain.High
              ? 'bg-green-500'
              : level === PotentialGain.Medium
                ? 'bg-green-300'
                : 'bg-gray-200'
          }`}
        />
        <div
          className={`h-2 w-6 rounded-sm ${level === PotentialGain.High ? 'bg-green-500' : 'bg-gray-200'}`}
        />
      </div>
    </div>
  );
}
